// src/pages/OrderReceipt.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const url = process.env.REACT_APP_SERVER_URL || "https://centralsoft.com.my";

export default function OrderReceipt() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios
      .get(`${url}/api/admin/orders/${orderId}/details`)
      .then((res) => {
        setOrder(res.data.order);
        setItems(res.data.items);

        // auto print for thermal printer
        setTimeout(() => {
          window.print();
          window.close();
        }, 1000);
      })
      .catch((err) => console.error("Error loading order:", err));
  }, [orderId]);

  if (!order) return <div>Loading receipt...</div>;

  return (
    <div style={{ fontFamily: "monospace", width: "280px", margin: "0 auto" }}>
      <h3 style={{ textAlign: "center" }}>Order Receipt</h3>
      <p>Table: {order.tableNumber}</p>
      <p>Date: {new Date(order.orderDate).toLocaleString()}</p>
      <hr />

      {items.map((item) => (
        <div key={item.orderItemID}>
          <strong>{item.foodName}</strong> × {item.quantity}
          <div>RM {(item.unitPrice * item.quantity).toFixed(2)}</div>
          {item.notes && <div>📝 {item.notes}</div>}

          {/* ✅ show addons */}
          {item.addons?.length > 0 && (
            <ul style={{ listStyle: "none", paddingLeft: "10px" }}>
              {item.addons.map((addon, index) => (
                <li key={index}>
                  ➕ {addon.addonName} × {addon.addonQuantity} — RM
                  {(addon.addonPrice * addon.addonQuantity).toFixed(2)}
                </li>
              ))}
            </ul>
          )}
          <hr />
        </div>
      ))}

      <p style={{ textAlign: "right" }}>
        <strong>Total: RM {Number(order.total).toFixed(2)}</strong>
      </p>
    </div>
  );
}
